import React, { useState, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';

import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { Rifm } from 'rifm'; 

import PageTitle from './PageTitle';
import ErrorDisplay from './ErrorDisplay';
import Waiting from './Waiting';
import CovidNotice from './CovidNotice';
import GeneralNotice from './GeneralNotice';

import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Divider from '@mui/material/Divider';
import Box from '@mui/material/Box';

import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';

import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import FormHelperText from '@mui/material/FormHelperText';

import InputAdornment from '@mui/material/InputAdornment';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import IconButton from '@mui/material/IconButton';

import Popper from '@mui/material/Popper';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';

import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';

import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';

import Snackbar from '@mui/material/Snackbar';
import SnackbarContent from '@mui/material/SnackbarContent';
import CloseIcon from '@mui/icons-material/Close';
import ErrorIcon from '@mui/icons-material/Error';

import CircularProgress from '@mui/material/CircularProgress';

import clsx from 'clsx';
import useStyles from '../styles/Styles';

import { loadSettings, loadMembersInfo, loadSuburbs, makeRequest, resetErrorMessage } from '../actions';
import _ from 'lodash';
import { isTrue, landlineMask, mobileMask } from '../utils';
import * as yup from 'yup';

const Join = () => {
	const init = useSelector(state => state.requests.init);
	const dispatch = useDispatch();
	const generalSettings = useSelector(state => state.settings.general);
	const memberSettings = useSelector(state => state.settings.members.data);
	const membershipTypes = useSelector(state => state.settings.membership_types.data);
	const classificationTypes = useSelector(state => state.settings.classifier_classification.data);
	const classifier1Types = useSelector(state => state.settings.classifier_classifier1.data);
	const classifier2Types = useSelector(state => state.settings.classifier_classifier2.data);
	const classifier3Types = useSelector(state => state.settings.classifier_classifier3.data);
	const memberLabels = useSelector(state => state.settings.labels_members.data);
	const suburbs = useSelector(state => state.suburbs.data);
	
	const classes = useStyles();
	
	const newMember = useSelector(state => state.requests.new_member);
	
	useEffect(() => {  
		if(!init){
			return;
		}
		dispatch(loadSettings('members'));
		dispatch(loadMembersInfo('general'));
	}, [dispatch, init]);
	
	useEffect(() => {
		dispatch(loadSuburbs(memberSettings.default_state));
	}, [memberSettings, dispatch])
	
	const submitNewMember = () => {
		
		const toSubmit = _.chain(_.union(fields[0], fields[1], fields[2]))
			.filter((f) => {return f.show && f.send})
			.keyBy('id')
			.mapValues((f) => {
				switch(f.type){
					case 'date':
						return _.isEmpty(f.atts.value) ? '' : f.atts.value.format('YYYY-MM-DD');
					case 'masked':
						return f.rifm.value;
					case 'checkbox':
						return f.atts.checked;
					case 'numeric':
						return +(f.atts.value);
					default: // text, select, suburb, password
						return f.atts.value
				}
				
			})
			.value();
		
		dispatch(makeRequest('new_member', toSubmit));
		setFormElements({...formElements, submitted: true});
		
	}
	
	const [memberTypeOptions, setMemberTypeOptions] = useState([{key: '', val: 'Select...'}]);
	
	const [classificationOptions, setClassificationOptions] = useState([{key: '', val: 'Select...'}]);
	useEffect(() => {
		if(classificationTypes){
			
			setClassificationOptions(_.map(classificationTypes, (ct) => {
				return {key: ct.code, val: ct.code}
			}));
		}
	}, [classificationTypes])
	
	const [classifier1Options, setClassifier1Options] = useState([{key: '', val: 'Select...'}]);
	useEffect(() => {
		if(classifier1Types){
			
			setClassifier1Options(_.map(classifier1Types, (ct) => {
				return {key: ct.code, val: ct.code}
			}));

		}
	}, [classifier1Types])
	
	const [classifier2Options, setClassifier2Options] = useState([{key: '', val: 'Select...'}]);
	useEffect(() => {
		if(classifier2Types){
			
			setClassifier2Options(_.map(classifier2Types, (ct) => {
				return {key: ct.code, val: ct.code}
			}));

		}
	}, [classifier2Types])
	
	const [classifier3Options, setClassifier3Options] = useState([{key: '', val: 'Select...'}]);
	useEffect(() => {
		if(classifier3Types){
			
			setClassifier3Options(_.map(classifier3Types, (ct) => {
				return {key: ct.code, val: ct.code}
			}));

		}
	}, [classifier3Types])
	
	const handleValidationErrors = (errors) => {
		console.log('Form validation errors:', errors);
		
		const copyV = _.cloneDeep(validator);
		_.each(errors, (e) => {
			copyV[e.path].error = true;
			copyV[e.path].message = e.message;
		});
		setValidator(copyV);
		setFormElements({...formElements, error: true, message: 'The form contains errors. Please correct them before proceeding.'});
	}
	
	const scrollToRef = (ref) => window.scrollTo(0, ref.current.offsetTop - 64);
	const anchorTop = useRef(null)
	const backToTop = () => scrollToRef(anchorTop);
	
	const steps = ['Part 1', 'Part 2', 'Part 3', 'Review, submit'];
	const [activeStep, setActiveStep] = useState(0);

	const handleNext = () => {
		switch(activeStep){
			case 0:
				schemas.part1.validate(part1, {abortEarly: false})
				.then((value) => {
					setActiveStep(activeStep + 1);
					backToTop();
				})
				.catch((err) => {
					handleValidationErrors(err.inner);
				});
				break;
			case 1:
				schemas.part2.validate(part2, {abortEarly: false})
				.then((value) => {
					setActiveStep(activeStep + 1);
					backToTop();
				})
				.catch((err) => {
					handleValidationErrors(err.inner);
				});
				break;
			case 2:
				schemas.part3.validate(part3, {abortEarly: false})
				.then((value) => {
					setActiveStep(activeStep + 1);
					backToTop();
				})
				.catch((err) => {
					handleValidationErrors(err.inner);
				});
				break;
			case 3:
				submitNewMember();
				setActiveStep(activeStep + 1);
				backToTop();
				break;
			default: 
				setActiveStep(activeStep + 1);
				backToTop();
				break;
		}
		
	};

	const handleBack = () => {
		setActiveStep(activeStep - 1);
		backToTop();
	};

	const [part1, setPart1] = useState({
		member_type: '',
		first_name: '',
		surname: '',
		preferred_name: '',
		address1: '',
		street: '',
		suburb: '',
		postcode: '',
		state: 'VIC',
		country: 'Australia',
		phone_home: '',
		phone_business: '',
		mobile: '',
		email: '',
		confirm_email: '',
	});
	
	// part1 is not in the dependency array b/c we don't want to run this every time part1 changes
	useEffect(() => {
		if(membershipTypes){
			const options = _.chain(membershipTypes)
				.filter({member_can_select: 1})
				.map((mt) => {
					return {key: mt.code, val: mt.code}
				})
				.sortBy((m) => {
					return m.key !== memberSettings.default_membership_type;
				}).value();
			
			setMemberTypeOptions(options);
			
			if(part1.member_type === '' && _.some(options, ['key', memberSettings.default_membership_type])){
				setPart1({...part1, member_type: memberSettings.default_membership_type, state: memberSettings.default_state });
			}
		} // eslint-disable-next-line
	}, [membershipTypes, memberSettings])
	
	const [part2, setPart2] = useState({
		birth_year: '',
		gender: '',
		employer: '',
		fax: '',
		occupation: '',
		registration: '',
		spare_field: '',
		number1: '',
		number2: '',
		tickets: '',
		classification: '',
		classifier1: '',
		classifier2: '',
		classifier3: '',
	});
	
	const [part3, setPart3] = useState({
		received_date: null,
		registration_date: null,
		checkbox1: false,
		checkbox2: false,
		checkbox3: false,
		checkbox4: false,
		emergency_contact: '',
		emergency_number: '',
		emergency_relationship: '',
		password: '',
		confirm_password: '',
		vaccinated: false,
		t_and_cs: false
	});

	const schemas = {
		part1: yup.object().shape({
			member_type: yup.string().required('Please make a selection'),
			first_name: yup.string().required('This field cannot be empty'),
			surname: yup.string().required('This field cannot be empty'),
			street: yup.string().required('This field cannot be empty'),
			suburb: yup.string().required('This field cannot be empty'),
			postcode: yup.string().matches(/^[0-9]{4}$/, {message: 'Please enter a 4-digit postcode'}),
			state: yup.string().required('Please make a selection'),
			phone_home: yup.string().matches(/^[(](\d{2})[)] (\d{4})-(\d{4})$/, { message: 'Please enter a 10-digit phone number including area code', excludeEmptyString: true }),
			phone_business: yup.string().matches(/^[(](\d{2})[)] (\d{4})-(\d{4})$/, { message: 'Please enter a 10-digit phone number including area code', excludeEmptyString: true }),
			mobile: yup.string().matches(/^(\d{4}) (\d{3}) (\d{3})$/, { message: 'Please enter 10-digit mobile number', excludeEmptyString: true }),
			email: yup.string().required('Please enter a valid email address').email('Please enter a valid email address'),
			confirm_email: yup.string().required('Please confirm your email address').email('Please enter a valid email address').oneOf([part1.email],'Email does not match'),
		}),
		part2: yup.object().shape({
			birth_year: yup.string().required('This field cannot be empty').matches(/^\d{4}$/, { message: 'Please enter a 4-digit year'})
			.test('valid-birth-year', 'Minimum joining age is 18. Is your birth year correct?',
				value => { 
					const intVal = _.toInteger(value); 
					const maxYear = (new Date()).getFullYear() - 18; 
					return (intVal <= maxYear); 
				}
			),
			gender: yup.string().required('Please make a selection'),
			occupation: yup.string().test('maybe-require-occupation', 'This field cannot be empty',
				value => {
					return (memberSettings.require_occuption && _.isEmpty(value) ? false : true);
				}
			), // conditional require
			number1: yup.string().matches(/^\d{1,6}$/, { message: 'Please enter a whole number between 0 and 999999', excludeEmptyString: true}),
			number2: yup.string().matches(/^(\d{1,10})(|\.\d{1,2})$/, { message: 'Please enter a number between 0 and 9999999999.99. Up to 2 decimal places are allowed.', excludeEmptyString: true}),
			tickets: yup.string().matches(/^\d{1,6}$/, { message: 'Please enter a whole number between 0 and 999999', excludeEmptyString: true}),
			registration: yup.string().test('maybe-require-registration', 'This field cannot be empty',
				value => {
					return (memberSettings.require_registration && _.isEmpty(value) ? false : true);
				}
			), // conditional require
		}),
		part3: yup.object().shape({
			received_date: yup.date().nullable()
			.min('1900-01-01', 'Minimum allowed date is 01/01/1900')
			.max('2100-01-01', 'Maximum allowed date is 01/01/2100')
			.typeError('Please enter a valid date in the format dd/mm/yyyy'),
			registration_date: yup.date().nullable(
			).min('1900-01-01', 'Minimum allowed date is 01/01/1900')
			.max('2100-01-01', 'Maximum allowed date is 01/01/2100')
			.typeError('Please enter a valid date in the format dd/mm/yyyy')
			.test('maybe-require-registration_date', 'This field cannot be empty',
				value => {
					return (memberSettings.require_registration_date && !(_.isDate(value)) ? false : true);
				}
			), // conditional require
			emergency_contact: yup.string().required('This field cannot be empty'),
			emergency_number: yup.string().required('This field cannot be empty'),
			emergency_relationship: yup.string().test('maybe-require-emergency_relationship', 'This field cannot be empty',
				value => {
					return (memberSettings.require_emergency_relationship && _.isEmpty(value) ? false : true);
				}
			), // conditional require
			password: yup.string().matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?!.*[<>\\&]).{8,20}$/, {message: 'Password must be 8-20 characters long, must contain a mix of uppercase and lowercase letters and numbers, and must not include any of these characters: <>\\&'}),
			confirm_password: yup.string().oneOf([part3.password],'Password does not match').required('This is a required field'),
			t_and_cs: yup.bool().test('maybe-require-t_and_cs', 'Please acknowledge that you agree to the terms and conditions',
				value => {
					return (isTrue(memberSettings.show_terms_and_conditions) && value === false ? false : true);
				}
			) // conditional require
		})
	};
	
	const [validator, setValidator] = useState({
		member_type: { error: false,  message: '' },
		first_name: { error: false,  message: '' },
		surname: { error: false,  message: '' },
		street: { error: false,  message: '' },
		suburb: { error: false,  message: '' },
		postcode: { error: false,  message: '' },
		state: { error: false,  message: '' },
		phone_home: { error: false,  message: '' },
		phone_business: { error: false,  message: '' },
		mobile: { error: false,  message: '' },
		email: { error: false,  message: '' },
		confirm_email: { error: false,  message: '' },
		birth_year: { error: false,  message: '' },
		occupation: { error: false,  message: '' },
		registration: { error: false,  message: '' },
		number1: { error: false,  message: '' },
		number2: { error: false,  message: '' },
		tickets: { error: false,  message: '' },
		gender: { error: false,  message: '' }, 
		received_date: { error: false,  message: '' },
		registration_date: { error: false,  message: '' },
		emergency_contact: { error: false,  message: '' },
		emergency_number: { error: false,  message: '' },
		emergency_relationship: { error: false,  message: '' },
		password: { error: false,  message: '' },
		confirm_password: { error: false,  message: '' },
		t_and_cs: { error: false,  message: '' }
	});
	
	const storeAndValidate = (part, key, value) => {
		switch(part){
			case 1:
				setPart1({...part1, [key]: value});
				break;
			case 2:
				setPart2({...part2, [key]: value});
				break;
			case 3:
				setPart3({...part3, [key]: value});
				break;
			default:
				break;
		}
		if(_.has(validator, key)){
			
			const copyV = _.cloneDeep(validator);
			
			schemas['part'+part].validateAt(key, {[key]: value})
			.then((val) => {
				copyV[key].error = false;
				copyV[key].message = '';
				
				if(key === 'email'){ 
					if(_.isEmpty(part1.confirm_email)){
						copyV.confirm_email.error = true;
						copyV.confirm_email.message = 'Please confirm your email address';
					} else if(value !== part1.confirm_email){
						copyV.confirm_email.error = true;
						copyV.confirm_email.message = 'Email does not match';
					} else {
						copyV.confirm_email.error = false;
						copyV.confirm_email.message = '';
					}
					
				} else if(key === 'birth_year'){
					const intVal = _.toInteger(value);
					const maxWarn = (new Date()).getFullYear() - 120;
					const minWarn = (new Date()).getFullYear() - memberSettings.minimum_joining_age
					if(intVal < maxWarn){
						copyV.birth_year.message = 'Warning: It looks like you are over 120 years old. Is your birth year correct?';
					} else if(intVal > minWarn){
						copyV.birth_year.message = 'Warning: It looks like you are younger than '+memberSettings.minimum_joining_age+'. Our preferred minimum joining age is '+memberSettings.minimum_joining_age+'. Is your birth year correct?';
					}
				} else if(key === 'suburb'){
					if(value.length > 3){
						suburbSelector(value);
					}
				}
				setValidator(copyV);
			})
			.catch((err) => {
				copyV[key].error = true;
				copyV[key].message = err.message;
				setValidator(copyV);
			});
		}
	}
	
	const [formElements, setFormElements] = useState({
		show_password: false,
		message: '',
		error: false,
		submitted: false
	});
	
	useEffect(() => {
		if(newMember.submitting){
			setFormElements(f => { return {...f, submitted: true}});
		} 
	}, [newMember])
	
	const setSuburb = (suburb) => {
		setPart1({...part1, suburb: suburb.suburb, state: suburb.state, postcode: suburb.postcode});
		setValidator({...validator, suburb: {error: false, message: ''}, state: {error: false, message: ''}, postcode: {error: false, message: ''}});
		setFilteredSuburbs([]);
	}
	
	let inputRef = useRef(null)
	const [filteredSuburbs, setFilteredSuburbs] = useState([]);
	
	const suburbSelector = (keyword) => {
		const upperKey = _.toUpper(keyword);
		const filtered = _.filter(suburbs, (s) => {
			return s.suburb.includes(upperKey);
		});
		
		setFilteredSuburbs(filtered);
	}
	
	const SuburbPopper = () => {
		return (
		<>
		<Popper id='suburb_popper' 
			open={part1.suburb.length > 3 && filteredSuburbs.length > 0} 
			anchorEl={inputRef.current}
			disablePortal={true}
			modifiers={[]}
		>
		<Paper elevation={2}>
		<ClickAwayListener onClickAway={() => setFilteredSuburbs([])}>
		<MenuList>
		{filteredSuburbs.map((s, i) => (
			<MenuItem key={i} onClick={() => setSuburb(s)}>
				{s.suburb} {s.postcode}
			</MenuItem>
		))}
		</MenuList>
		</ClickAwayListener>
		</Paper>
		</Popper>
		</>
	)};
	
	const fields = [
		[
			{
				type: "select",
				id: "member_type",
				atts: {
					label: memberLabels.member_type,
					value: part1.member_type,
					required: true,
				},
				options: memberTypeOptions,
				show: true,
				send: true,
			},
			{
				id: "member_type_divider",
				divider: true,
				show: true
			},
			{
				id: "first_name",
				atts: {
					label: "First name",
					autoComplete: "given-name",
					value: part1.first_name,
					required: true,
				},
				show: true,
				send: true,
			},
			{
				id: "surname",
				atts: {
					label: memberLabels.surname,
					autoComplete: "family-name",
					value: part1.surname,
					required: true,
				},
				show: true,
				send: true,
			},
			{
				id: "preferred_name",
				atts: {
					label: "Preferred name",
					autoComplete: "given-name",
					value: part1.preferred_name,
				},
				show: memberSettings.show_preferred_name,
				send: true,
			},
			{
				id: "name_divider",
				divider: true,
				show: true
			},
			{
				id: "address1",
				atts: {
					label: memberLabels.address1,
					autoComplete: "apartment",
					value: part1.address1,
				},
				fw: true,
				show: memberSettings.show_address1,
				send: true,
			},
			{
				id: "street",
				atts: {
					label: memberLabels.street,
					autoComplete: "street-address",
					required: true,
					value: part1.street,
				},
				fw: true,
				show: true,
				send: true,
			},
			{
				type: 'suburb',
				id: "suburb",
				atts: {
					label: memberLabels.suburb,
					autoComplete: "address-level2 ",
					value: part1.suburb,
					required: true,
				},
				show: true,
				send: true,
			},
			{
				id: "postcode",
				atts: {
					label: memberLabels.postcode,
					autoComplete: "postal-code",
					value: part1.postcode,
					required: true,
				},
				show: true,
				send: true,
			},
			{
				type: "select",
				id: "state",
				atts: {
					label: memberLabels.state,
					value: part1.state, 
					required: true
				},
				options: [ {key: 'ACT', val: 'ACT'}, {key: 'NSW', val: 'NSW'}, {key: 'NT', val: 'NT'}, {key: 'QLD', val: 'QLD'}, {key: 'SA', val: 'SA'}, {key: 'TAS', val: 'TAS'}, {key: 'VIC', val: 'VIC'}, {key: 'WA', val: 'WA'}
				],
				show: true,
				send: true,
			},
			{
				id: "country",
				atts: {
					label: "Country",
					autoComplete: "country-name",
					value: part1.country,
				},
				show: memberSettings.show_country,
				send: true,
			},
			{
				id: "address_divider",
				divider: true,
				show: true
			},
			{
				id: "email",
				atts: { 
					label: "Email",
					autoComplete: "email",
					type: "email",
					value: part1.email,
					required: true
				},
				show: true,
				send: true,
			},
			{
				id: "confirm_email",
				atts: {
					label: "Confirm email",
					type: "email",
					autoComplete: "off",
					value: part1.confirm_email,
					required: true
				},
				show: true,
			},
			{
				type: 'masked',
				id: "phone_home",
				atts: {
					label: memberLabels.phone_home,
					autoComplete: "tel-home",
				},
				rifm: {
					value:part1.phone_home,
					format:landlineMask,
					accept: /\d+/g,
				},
				show: true,
				send: true,
			},
			{
				type: 'masked',
				id: "phone_business",
				atts: {
					label: memberLabels.phone_business,
					autoComplete: "tel-work",
				},
				rifm: {
					value: part1.phone_business,
					format:landlineMask,
					accept: /\d+/g,
				},
				show: memberSettings.show_phone_business,
				send: true,
			},
			{
				type: 'masked',
				id: "mobile",
				atts: {
					label: memberLabels.mobile,
					autoComplete: "tel-national",
				},
				rifm: {
					value: part1.mobile,
					format:mobileMask,
					accept: /\d+/g,
				},
				show: true,
				send: true,
			},
		],[
			{
				id: "birth_year",
				type: "numeric",
				atts: {
					label: "Year of birth",
					autoComplete: "bday-year",
					value: part2.birth_year,
					required: true,
				},
				show: true,
				send: true,
			},
			{
				type: "select",
				id: "gender",
				atts: {
					label: "Gender",
					value: part2.gender, 
					required: true
				},
				options: [ {key: 'F', val: 'Female'}, {key: 'M', val: 'Male'}, {key: 'O', val: 'Other'}
				],
				show: true,
				send: true,
			},
			{
				id: "employer",
				atts: {
					label: memberLabels.employer,
					autoComplete: "off",
					value: part2.employer,
				},
				show: memberSettings.show_employer,
				send: true,
			},
			{
				id: "fax",
				atts: {
					label: memberLabels.fax,
					autoComplete: "off",
					value: part2.fax,
				},
				show: memberSettings.show_fax,
				send: true,
			},
			{
				id: "occupation",
				atts: {
					label: memberLabels.occupation,
					autoComplete: "off",
					value: part2.occupation,
					required: (isTrue(memberSettings.require_occuption)),
				}, 
				show: memberSettings.show_occupation,
				send: true,
			},
			{
				id: "registration",
				atts: {
					label: memberLabels.registration,
					autoComplete: "off",
					value: part2.registration,
					required: (isTrue(memberSettings.require_registration))
				}, 
				show: memberSettings.show_registration,
				send: true,
			},
			{
				id: "spare_field",
				atts: {
					label: memberLabels.spare_field,
					autoComplete: "off",
					value: part2.spare_field,
				}, 
				show: memberSettings.show_spare_field,
				send: true,
			},
			{
				id: "number1",
				type: "numeric",
				atts: {
					label: memberLabels.number1,
					value: part2.number1,
				},
				show: memberSettings.show_number1,
				send: true,
			},
			{
				id: "number2",
				type: "numeric",
				atts: {
					label: memberLabels.number2,
					value: part2.number2,
				},
				show: memberSettings.show_number2,
				send: true,
			},
			{
				id: "tickets",
				type: "numeric",
				atts: {
					label: memberLabels.tickets,
					value: part2.tickets,
				},
				show: memberSettings.show_tickets,
				send: true,
			},
			{
				type: "select",
				id: "classification",
				atts: {
					label: memberLabels.classification,
					value: part2.classification, 
				},
				options: classificationOptions,
				show: memberSettings.show_classification,
				send: true,
			},
			{
				type: "select",
				id: "classifier1",
				atts: {
					label: memberLabels.classifier1,
					value: part2.classifier1, 
				},
				options: classifier1Options,
				show: memberSettings.show_classifier1,
				send: true,
			},
			{
				type: "select",
				id: "classifier2",
				atts: {
					label: memberLabels.classifier2,
					value: part2.classifier2, 
				},
				options: classifier2Options,
				show: memberSettings.show_classifier2,
				send: true,
			},
			{
				type: "select",
				id: "classifier3",
				atts: {
					label: memberLabels.classifier3,
					value: part2.classifier3, 
				},
				options: classifier3Options,
				show: memberSettings.show_classifier3,
				send: true,
			},
		],[
			{
				type: "date",
				id: "received_date",
				atts: {
					outer: {
						label: memberLabels.received_date,
						inputFormat:"DD/MM/YYYY",
						value: part3.received_date,
					},
					inner: {
						placeholder: memberLabels.received_date,
						autoComplete:"off",
					}	
				},
				show: memberSettings.show_received_date,
				send: true,
			},
			{
				type: "date",
				id: "registration_date",
				atts: {
					outer: {
						label: memberLabels.registration_date,
						inputFormat:"DD/MM/YYYY",
						value: part3.registration_date,
					},
					inner: {
						placeholder: memberLabels.registration_date,
						autoComplete:"off",
						required: (isTrue(memberSettings.require_registration_date))
					}	
				},
				show: memberSettings.show_registration_date,
				send: true,
			},
			{
				label: memberLabels.checkbox1,
				type: "checkbox",
				id: "checkbox1",
				atts: {
					checked: part3.checkbox1,
					value: "checkbox1",
				},
				show: memberSettings.show_checkbox1,
				send: true,
			},
			{
				label: memberLabels.checkbox2,
				type: "checkbox",
				id: "checkbox2",
				atts: {
					checked: part3.checkbox2,
					value: "checkbox2",
				},
				show: memberSettings.show_checkbox2,
				send: true,
			},
			{
				label: memberLabels.checkbox3,
				type: "checkbox",
				id: "checkbox3",
				atts: {
					checked: part3.checkbox3,
					value: "checkbox3",
				},
				show: memberSettings.show_checkbox3,
				send: true,
			},
			{
				label: memberLabels.checkbox4,
				type: "checkbox",
				id: "checkbox4",
				atts: {
					checked: part3.checkbox4,
					value: "checkbox4",
				},
				show: memberSettings.show_checkbox4,
				send: true,
			},
			{
				id: "checkbox_divider",
				divider: true,
				show: (memberSettings.show_received_date || memberSettings.show_registration_date ||
					memberSettings.show_checkbox1 || memberSettings.show_checkbox2 ||
					memberSettings.show_checkbox3 || memberSettings.show_checkbox4)
			},
			{
				id: "emergency_contact",
				atts: {
					label: memberLabels.emergency_contact,
					required: true,
					value: part3.emergency_contact,
					autoComplete: "emergency-contact",
					name: "emergency-contact"
				},
				show: true,
				send: true,
			},
			{
				id: "emergency_number",
				atts: {
					label: memberLabels.emergency_number,
					required: true,
					value: part3.emergency_number,
					autoComplete: "emergency-number",
					name: "emergency-number"
				},
				show: true,
				send: true,
			},
			{
				id: "emergency_relationship",
				atts: {
					label: memberLabels.emergency_relationship,
					value: part3.emergency_relationship,
					required: (isTrue(memberSettings.require_emergency_relationship)),
					autoComplete: "emergency-relationship",
					name: "emergency-relationship"
				},
				show: memberSettings.show_emergency_relationship,
				send: true
			},
			{
				id: "emergency_divider",
				divider: true,
				show: true,
			},
			{
				label: 'Are you ' + memberLabels.fully_vaccinated + ' against COVID-19?',
				type: "checkbox",
				id: "vaccinated",
				atts: {
					checked: part3.vaccinated,
					value: "vaccinated",
				},
				show: memberSettings.vaccine_rules_on,
				send: memberSettings.vaccine_rules_on,
			},
			{
				id: "vax_divider",
				divider: true,
				show: true,
			},
			{
				id: "password",
				type: "password",
				atts: {
					label: "Password",
					required: true,
					autoComplete: "new-password",
					name: "new-password",
					value: part3.password,
				},
				show: true,
				send: true,
			},
			{
				id: "confirm_password",
				type: "password",
				atts: {
					label: "Confirm password",
					required: true,
					autoComplete: "new-password",
					name: "confirm-new-password",
					value: part3.confirm_password,
				},
				show: true,
			},
			{
				label: memberSettings.terms_and_conditions_note,
				type: "t_and_cs",
				id: "t_and_cs",
				fw: true,
				atts: {
					checked: part3.t_and_cs,
					value: "t_and_cs",
					required: isTrue(memberSettings.show_terms_and_conditions)
				},
				show: memberSettings.show_terms_and_conditions,
			},
		]
	];

	const reviewList = () => {
		const showFields = _.chain(_.union(fields[0], fields[1], fields[2]))
			.filter((f) => {return f.show && f.send})
			.map((f) => {
				switch(f.type){
					case 'date':
						return {label: f.atts.label, value: _.isEmpty(f.atts.value) ? '' : f.atts.value.format('D MMM YYYY')}
					case 'masked':
						return {label: f.atts.label, value: f.rifm.value }
					case 'checkbox':
					case 't_and_cs':
						return {label: f.label, value: f.atts.checked ? 'Yes' : 'No'};
					case 'password':
						return {label: f.atts.label, value: _.repeat('*', f.atts.value.length)};
					default: // text, select, suburb
						return {label: f.atts.label, value: f.atts.value}
				}
				
			})
			.value();

		return (
			<Grid container spacing={1}>
			{showFields.map((f, i) => (
				<Grid item key={i} xs={12} md={6}>
				<ListItem component="div" divider={true}>
				<ListItemText primary={f.label} secondary={f.value ? f.value : <>&mdash;</>} />
				</ListItem>
				</Grid>
			))}
			</Grid>
	)}

	const renderField = (field) => {
		switch(field.type){
			case 'checkbox':
				return (<FormControlLabel
					control={
					  <Checkbox
					  onChange={(event) => storeAndValidate(activeStep + 1, field.id, event.target.checked)}
					  id={field.id}
					  {...field.atts}
						color="primary"
					  />
					}
					label={field.label}
				  />);
			case 't_and_cs':
				return (<FormControl variant="standard">
				<FormControlLabel
					control={
					  <Checkbox color="primary"
					  onChange={(event) => storeAndValidate(activeStep + 1, field.id, event.target.checked)}
					  id={field.id}
						{...field.atts}
					  />
					}
					label={field.label}
				  />
				
				{validator[field.id].error ? 
				<FormHelperText
					error={validator[field.id].error}
				>{validator[field.id].message}</FormHelperText>
				: null}
				{memberSettings.terms_and_conditions_url ?
				<FormHelperText>
				<a href={memberSettings.terms_and_conditions_url} 
						target='_blank'
						rel="noopener noreferrer">
				Read the terms and conditions
				</a>
				</FormHelperText>
				: null }
				</FormControl>);
			case 'date':
				return (<DatePicker 
						closeOnSelect={true}
						className={classes.datePicker}
						InputAdornmentProps={{position: "end"}}
						minDate='1900-01-01'
						maxDate='2100-01-01'
						onChange={(date) => storeAndValidate(activeStep + 1, field.id, date)}
						{...field.atts.outer}
						renderInput={(props) => <TextField {...props}
							fullWidth
							error={validator[field.id] && validator[field.id].error}
							helperText={validator[field.id] && validator[field.id].error ? validator[field.id].message : ''}
							id={field.id} // here?
							{...field.atts.inner}
						/>}
					/>
				);
			case 'select':
				return (<TextField
					variant="outlined"
					fullWidth
					select
					error={validator[field.id] && validator[field.id].error}
					helperText={validator[field.id] && validator[field.id].error ? validator[field.id].message : ''}
					onChange={(event) => storeAndValidate(activeStep + 1, field.id, event.target.value)}
					id={field.id}
					{...field.atts}
				>
				{field.options.map((o, k) => (
					<MenuItem key={k} value={o.key}>{o.val}</MenuItem>
				))}
				</TextField>);
			case 'masked':
				return (<Rifm {...field.rifm} 
					onChange={(val) => storeAndValidate(activeStep + 1, field.id, val)}
					>
					{({ value, onChange }) => (
					  <TextField
						variant="outlined"
						fullWidth
						error={validator[field.id] && validator[field.id].error}
						helperText={validator[field.id] && validator[field.id].message ? validator[field.id].message : ''}
						id={field.id}
						{...field.atts}
						value={value}
						onChange={onChange}
					  />
					)}
				</Rifm>);
			case 'suburb':
				return (<><TextField
					variant="outlined"
					fullWidth
					error={validator[field.id] && validator[field.id].error}
					helperText={validator[field.id] && validator[field.id].message ? validator[field.id].message : ''}
					onChange={(event) => {storeAndValidate(activeStep + 1, field.id, event.target.value); }}
					id={field.id}
					ref={inputRef}
					{...field.atts}
				/>
				<SuburbPopper />
				</>)
			case 'password':
				return (<>
					{field.id === 'password' ?
					<Box component='input' type='text' 
						name='username' 
						autoComplete="username" 
						sx={{
							visibility: 'hidden',
							height: 0,
							width: 0,
							position: 'absolute',
							border: 0,
							left: '-1000px'
						}}
						value={part1.email}
						onChange={e => { return; }}
					/>
					: null}
					<TextField
					variant="outlined"
					fullWidth
					error={validator[field.id] && validator[field.id].error}
					helperText={validator[field.id] && validator[field.id].message ? validator[field.id].message : ''}
					type={formElements.show_password ? "text" : "password"}
					InputProps={{
						endAdornment: (
						  <InputAdornment position="end">
							<IconButton
							  aria-label="toggle password visibility"
							  onClick={() => setFormElements({...formElements, show_password: !formElements.show_password})}
							  onMouseDown={(event) => event.preventDefault()}
							  edge="end"
							>
							  {formElements.show_password ? <Visibility /> : <VisibilityOff />}
							</IconButton>
						  </InputAdornment>
						)
					}}
					onChange={(event) => storeAndValidate(activeStep + 1, field.id, event.target.value)}
					id={field.id}
					{...field.atts}
				/></>);
			default:
				return (<TextField
					variant="outlined"
					fullWidth
					error={validator[field.id] && validator[field.id].error}
					helperText={validator[field.id] && validator[field.id].message ? validator[field.id].message : ''}
					onChange={(event) => storeAndValidate(activeStep + 1, field.id, event.target.value)}
					id={field.id}
					{...field.atts}
				/>);
		}
	}
	
	const SubmitResult = () => {
		
		if(newMember.submitting){
			return <>
			<Typography variant="h6" align="center" gutterBottom>
			Submitting...
			</Typography>
			<Typography variant="body1">Submitting your new member request. Please wait.</Typography>
			<div className={classes.actionButton}>
			<CircularProgress />
			</div>
			</>
		} else if (formElements.submitted && newMember.member_no){
			return <>
			<Typography variant="h6" align="center" gutterBottom>
			Success
			</Typography>
			<Typography variant="body1" gutterBottom>Congratulations {memberSettings.show_preferred_name && part1.preferred_name ? part1.preferred_name : part1.first_name}, you have successfully joined {generalSettings.data.display_name}.</Typography>
			<Typography variant="body1">Your member number is:</Typography>
			<Typography variant="h5" align="center">{newMember.member_no}</Typography>
			<Typography variant="body1" gutterBottom>Please write your member number down before proceeding.</Typography>
			<Typography variant="body1" gutterBottom>You can now log in to U-MAS using your member number or your email address, and the password that you specified when joining up just now.</Typography>
			<div className={classes.actionButton}>
			<Link to="/login"><Button color="primary" variant="contained" >Log in</Button></Link>
			</div>
			</>
		} else if (formElements.submitted && !newMember.member_no){
			return <>
			<Typography variant="h6" align="center" gutterBottom>
			Submission failed
			</Typography>
			<Typography variant="body1" align="center" gutterBottom>
			Check the error message above.
			</Typography>
			</>
		} else {
			return null;
		}
		
	}
	
	return (
	<>
	<div ref={anchorTop}></div>
	{formElements.submitted ?
	<ErrorDisplay 
		extra_button={{
			atts: {
				onClick: () => {
					setActiveStep(0);
					setFormElements({...formElements, submitted: false});
					dispatch(resetErrorMessage());
				}
			},
			text: 'Return to form',
		}}
	/> : 
	<ErrorDisplay />
	}
	<Paper className={clsx(classes.innerContent, classes.page)} square={true}>
	<PageTitle title='Join' />
		{generalSettings.expires > 0 && (!isTrue(generalSettings.data.joining_on) || generalSettings.data.umas_status === 0) ? (
		<>
		<Typography variant="h6">
		Joining is off
		</Typography>
		<Typography variant="body2">
		Sorry, joining is currently disabled. Please check again later, or <Link to="/contact">contact us</Link> for more information.
		</Typography>
		</>
		) : (
		<>
		<Typography variant="body2">
		Fill out and submit this form in order to join {generalSettings.data.display_name}.
		</Typography>
		<Stepper alternativeLabel activeStep={activeStep} className={classes.stepper} style={{ padding: 24 }}>
			{steps.map(label => (
				<Step key={label}>
					<StepLabel>{label}</StepLabel>
				</Step>
			))}
         </Stepper>
		 {generalSettings.expires === 0 ? (
			<Waiting
				message='Preparing form. Please wait...'
			/>
		) : 
		 (activeStep === steps.length ? (
			<SubmitResult/>
		 ) : (
			<>
			<Typography variant="h6" align="center" gutterBottom>
				{steps[activeStep]}
			</Typography>
			{activeStep === steps.length - 1 ? reviewList() : (
			<form className={classes.form} autoComplete="off" noValidate> 
			<Grid container spacing={2}>
				{fields[activeStep].map((f, i) => {
					return f.show ? (
					f.divider ? (<Divider key={f.id} variant="middle" component='div' />) : (
					<Grid item id={"field-"+f.id} key={f.id} xs={12} md={f.fw ? 12 : 6} >
					{renderField(f)}
					</Grid>
					)) : null
				})}
			</Grid>
			</form>
			)}
			<div className={classes.formButtons}>
                  {activeStep !== 0 && (
                    <Button onClick={handleBack} className={classes.button}>
                      Back
                    </Button>
                  )}
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleNext}
                    className={classes.button}
                  >
                    {activeStep === steps.length - 1 ? 'Submit' : 'Next'}
                  </Button>
            </div>
			<Snackbar
				anchorOrigin={{
					vertical: 'bottom',
					horizontal: 'center'
				}}
				open={formElements.error}
				onClose={() => setFormElements({...formElements, error: false})}
				autoHideDuration={null}
			>
			<SnackbarContent
				aria-describedby='form-message'
				message={<span id="form-message" className={classes.snackMessage}>
					<ErrorIcon className={classes.errorSnack} />
					{formElements.message}
				</span>}
				action={[
					<IconButton
					key="close"
					aria-label="close"
					color="inherit"
					onClick={() => setFormElements({...formElements, error: false})}
					>
					<CloseIcon />
					</IconButton>,
				]}
			/>
			</Snackbar>
			<CovidNotice />
			<GeneralNotice />
			</>
		 ))}
		</>
	)}
	</Paper>
	</>
)};

export default Join
